import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/Header/Header.jsx";
import Footer from "../components/Footer/Footer.jsx";

const PublicLayout = () => {
    const location = useLocation();
    const isEmbed = new URLSearchParams(location.search).get('embed') === 'true';

    return (
        <>
            {!isEmbed && <Header />}

            <main className="layout">
                <Outlet />
            </main>

            {!isEmbed && <Footer />}
        </>
    );
};

export default PublicLayout;